import React, { useState } from 'react';
import './FranchiseIntro.css';
import InfoRequestModal from './InfoRequestModal.tsx';

const FranchiseIntro: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <section className="franchise-intro">
      <div className="franchise-intro__content">
        <h2 className="franchise-intro__title">
          WELCOME TO SWEETSPOT FRANCHISING
        </h2>
        <div className="franchise-intro__divider" />
        <p className="franchise-intro__description">
          Opening a successful dispensary can be extremely costly and difficult
          to navigate. We've created a business in a box to help mitigate your
          risk and protect your investment. Through our franchise model, we
          offer the opportunity to become part of this high growth industry.
          Our experienced team of industry leaders will guide you every step
          of the way.
        </p>
        <div className="franchise-intro__button">
          <button
            className="franchise-intro__cta-button"
            onClick={handleOpenModal}
          >
            REQUEST INFORMATION
          </button>
        </div>
      </div>

      <InfoRequestModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />
    </section>
  );
};

export default FranchiseIntro;
